// extracted by mini-css-extract-plugin
module.exports = {"subHero":"subHero-module--sub-hero--1PgdM"};